"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentRequestGroupBancontactContainer = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_types_1 = require("@as-react/common-types");
const common_components_1 = require("@as-react/common-components");
const PaymentRequestGroupBancontact_1 = require("../../../components/checkout/payment-request/PaymentRequestGroupBancontact");
const common_queries_1 = require("@as-react/common-queries");
const react_query_1 = require("@tanstack/react-query");
const QueryClientUtil_1 = tslib_1.__importDefault(require("../../../util/QueryClientUtil"));
const PaymentRequestGroupBancontactContainer = ({ paymentRequestId, totalPrice, group, }) => {
    const { defaultRequestParams, servicesEndpoint } = (0, common_components_1.useAemConfig)();
    const { postInitSaferpayAlternative, postRequestSaferpayToken } = (0, common_queries_1.checkoutMutations)({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { mutateAsync: postInitSaferpayAlternativeMutation } = (0, react_query_1.useMutation)(postInitSaferpayAlternative);
    const { mutateAsync: postRequestSaferpayTokenMutation } = (0, react_query_1.useMutation)(postRequestSaferpayToken);
    const { getStatusSaferpayAlternative } = (0, common_queries_1.checkoutQueries)({
        servicesEndpoint: servicesEndpoint,
        defaultRequestParams: defaultRequestParams,
    });
    const handleSubmit = (saferpayFieldsToken) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (saferpayFieldsToken) {
            const response = yield postRequestSaferpayTokenMutation({ paymentRequestId, saferpayFieldsToken });
            if (response === null || response === void 0 ? void 0 : response.redirectUrl) {
                location.href = response.redirectUrl;
            }
        }
    });
    const handleInitAlternative = () => {
        return postInitSaferpayAlternativeMutation(paymentRequestId);
    };
    const handlePollingAlternative = (requestId) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const result = yield QueryClientUtil_1.default.fetchQuery(getStatusSaferpayAlternative(requestId));
        if ((result === null || result === void 0 ? void 0 : result.status) &&
            (result.status === common_types_1.SaferpayAltStatusResult.CAPTURED || result.status === common_types_1.SaferpayAltStatusResult.FAILURE)) {
            if (result.redirectUrl) {
                return result.redirectUrl;
            }
            return '';
        }
        return '';
    });
    return ((0, jsx_runtime_1.jsx)(PaymentRequestGroupBancontact_1.PaymentRequestGroupBancontact, { selected: true, group: group, totalPrice: totalPrice, onSubmit: handleSubmit, onInitAlternative: handleInitAlternative, onPollingAlternative: handlePollingAlternative }));
};
exports.PaymentRequestGroupBancontactContainer = PaymentRequestGroupBancontactContainer;
